/**
 * @description 积分盒子，用于显示总分和加分气泡
 * @author
 */

import React from 'react';
import { components } from 'common';
const { If } = components;
import { toKUnit } from '@umu/umu-util';
import { $window } from '@umu/umu-dom';
import { getCourseMyPointsRank } from '@umu/umu-api';
import './coursePointsBox.scss';

const DURATION = 2000; // 加分持续时间
const MAX_NUM_COUNT = 7;
const ANIMATE_OPTION = {
    delay: 50,
};

export interface IPoints {
    is_minus: number; // 0 = false, 1 = true
    point: number; // 当前分数
    rank_type: number; //
    student_id: string;
    total_points: number;
    type: number;
}

export interface IProps {
    groupId: number;
    pointsList: IPoints[];
}

export interface IStates {
    totalPoints: number | string; // 当前总分
    coursePoints: number; // 本次加分
    showPoints: boolean; // 是否显示加分气泡
    showTotalPoints: boolean; // 是否显示加总分效果
}

function formatPoints(points: number) {
    return points.toString().length > MAX_NUM_COUNT ? toKUnit(points, 0) : points.toString();
}

export default class CoursePointsBox extends React.Component<IProps, IStates> {
    public totalPoints = 0;
    public animatedStatus = false;
    public pointsTimerId = 0;
    public totalPointsTimerId = 0;

    constructor(props: IProps) {
        super(props);
        this.reset();
        this.state = {
            totalPoints: 0, // 当前总分
            coursePoints: 0, // 本次加分
            showPoints: false, // 是否显示加分气泡
            showTotalPoints: false, // 是否显示加总分效果
        };
    }

    public componentDidMount() {
        this.getCoursePoints();
    }

    /**
     * 如果是多个加分,再交互上合并成一个加分显示
     * 后端会返回2种数据类型，数组和plainObject
     */
    public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        const pointsList = nextProps.pointsList;
        if (Array.isArray(pointsList) && pointsList.length > 0) {
            const list = pointsList.filter((item) => {
                return !!item.total_points;
            });
            this.mergerPoints(list);
        } else if (!Array.isArray(pointsList) && typeof pointsList === 'object') {
            this.mergerPoints([pointsList]);
        }
    }

    public componentWillUnmount() {
        this.reset();
    }

    public reset = () => {
        this.totalPoints = 0;
        this.animatedStatus = false;
        this.pointsTimerId = 0;
        this.totalPointsTimerId = 0;
    };

    public clearTask = () => {
        clearTimeout(this.pointsTimerId);
        clearTimeout(this.totalPointsTimerId);
    };

    /**
     * 合并分数
     */
    public mergerPoints = (pointsList: IPoints[]) => {
        if (!Array.isArray(pointsList)) {
            return;
        }
        this.clearTask();

        let coursePoints = 0;
        let totalPoints = 0;

        for (let i = 0, len = pointsList.length; i < len; i++) {
            coursePoints = coursePoints + parseFloat((pointsList[i].point || 0) + '');
        }
        coursePoints = parseFloat(coursePoints.toFixed(2));
        // 按照计算顺序，最后一个的总分即是当前总分。后端不能异步计算，分数需要锁，有一种可能是数组的顺序有bug
        const theLastPointsItem = pointsList[pointsList.length - 1] || {};
        totalPoints = theLastPointsItem.total_points;
        if (totalPoints === this.totalPoints || coursePoints === 0) {
            return;
        }
        this.totalPoints = totalPoints;

        // 如果是负分，不显示气泡
        if (coursePoints <= 0) {
            this.setState({
                totalPoints: formatPoints(this.totalPoints),
                showPoints: false,
                showTotalPoints: false,
            });
        } else {
            this.beginAnimate();

            this.setState({
                // totalPoints: pointsList[pointsList.length - 1].total_points - coursePoints,
                totalPoints: formatPoints(this.totalPoints),
                coursePoints,
                showPoints: true,
                showTotalPoints: true,
            });
        }
    };

    // 改成异步task
    public beginAnimate = () => {
        this.animatedStatus = true;
        this.pointsTimerId = $window.setTimeout(() => {
            this.setState({
                showPoints: false,
                showTotalPoints: true,
            });
        }, DURATION * 1 + ANIMATE_OPTION.delay);

        this.totalPointsTimerId = $window.setTimeout(() => {
            this.stopAnimate();
            this.setState({
                showTotalPoints: false,
            });
        }, DURATION * 1.5 + ANIMATE_OPTION.delay);
    };

    public stopAnimate = () => {
        this.animatedStatus = false;
    };

    /**
     * 获取总分
     */
    public getCoursePoints = () => {
        const rankType = 1;
        getCourseMyPointsRank({
            group_id: this.props.groupId,
            rank_type: rankType.toString(),
        }).then((output) => {
            if (output.data) {
                this.totalPoints = parseFloat((+output.data.rank_arr[rankType].total_points || 0).toFixed(2));
                this.setState({
                    totalPoints: formatPoints(this.totalPoints),
                });
            }
        });
    };

    public render() {
        // tslint:disable-next-line:max-line-length
        const addPointsCls = `animated points-bubble ${
            this.state.showPoints && this.animatedStatus ? 'animate-add-points' : ''
        }`;

        // tslint:disable-next-line:max-line-length
        const totalPointsCls = `animated points-num ${
            this.state.showTotalPoints && this.animatedStatus ? 'animate-total-points' : ''
        }`;

        return (
            <div className="course-points-box">
                <If condition={!!this.state.coursePoints}>
                    <div className={addPointsCls}>+{this.state.coursePoints}</div>
                </If>

                <div className="total-points">
                    <i className="icon icon-course-points" />
                    <span className={totalPointsCls}>{this.state.totalPoints}</span>
                </div>
            </div>
        );
    }
}
